"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTagStore = void 0;
const pinia_1 = require("pinia");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const vue_1 = require("vue");
const securityStore_1 = require("../security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
exports.useTagStore = (0, pinia_1.defineStore)('tagStore', () => {
    const securityStore = (0, securityStore_1.useSecurityStore)();
    const getDefaultTags = () => ({
        columns: {
            nameColumn: { display: false, value: '' },
            sizeColumn: { display: false, value: '' },
            tyreLabelingColumn: { display: false, value: '' },
            idColumn: { display: false, value: '' },
            listPriceColumn: { display: false, value: '' },
            wholesalePriceColumn: { display: false, value: '' },
            retailPriceColumn: { display: false, value: '' },
            customPriceColumn: { display: false, value: '' },
            stockColumn: { display: false, value: '' },
            cartColumn: { display: false, value: '' }
        },
        switches: {
            zeroStockSwitch: { display: false, value: false },
            setSwitch: { display: false, value: false },
            retailPriceSwitch: { display: false, value: false },
            grossPriceSwitch: { display: false, value: false },
            pairSearchSwitch: { display: false, value: false },
            customPriceSwitch: { display: false, value: false }
        },
        searchViews: {
            passengerTyresSearch: { display: false },
            truckTyreSearch: { display: false },
            agriculturalAndIndustrialTyresSearch: { display: false },
            forkliftTyresSearch: { display: false },
            motorcycleTyresSearch: { display: false },
            rimSearchByCarSearch: { display: false },
            rimSearch: { display: false },
            spareWheelsSearch: { display: false },
            tubeAndTapeProductSearch: { display: false },
            accessoriesSearch: { display: false },
            skuSearch: { display: false }
        }
    });
    const tags = (0, vue_1.reactive)(getDefaultTags());
    const isExportPartner = (0, vue_1.computed)(() => { var _a, _b; return (_b = (_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.EXPORT_PARTNER)) !== null && _b !== void 0 ? _b : false; });
    // TODO: Configból jöjjön a valuta.
    const customerCurrencyCode = (0, vue_1.computed)(() => { var _a, _b; return (_b = (_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.currencyCode) !== null && _b !== void 0 ? _b : 'HUF'; });
    const activeColumnCount = (0, vue_1.computed)(() => Object.values(tags.columns).reduce((count, column) => count + (column.display ? 1 : 0), 0));
    const calculateTags = (type, switches) => {
        // Először reseteljük az összes tag-et.
        reset();
        // Aktív kereső nézet beállítása.
        setActiveSearchView(type);
        // Configok lekérése.
        const { config, configByType } = getConfigs(type);
        if (configByType) {
            // Oszlopok megjelenítésének és értékének beállítása a config alapján.
            setColumnsDisplayAndValue(configByType);
        }
        if (config && configByType) {
            // Kapcsolók megjelenítésének és értékének beállítása a config és a paraméterben kapott kapcsolók értékeinek alapján.
            setSwitchesDisplayAndValue(config, configByType, switches);
        }
        handleExportPartner();
        handleRetailPriceSwitch();
        handleCustomPriceSwitch();
    };
    const setActiveSearchView = (type) => {
        if (!type)
            return;
        Object.keys(tags.searchViews).forEach((view) => {
            tags.searchViews[view].display = (view === type);
        });
    };
    const getConfigs = (type) => {
        return {
            config: ShopConfig_1.ShopConfig.getTags(),
            configByType: ShopConfig_1.ShopConfig.getTagsByType(type)
        };
    };
    const setColumnsDisplayAndValue = (configByType) => {
        Object.keys(tags.columns).forEach((key) => {
            tags.columns[key].display = false;
            tags.columns[key].value = '';
            if (!(configByType === null || configByType === void 0 ? void 0 : configByType.disabledTags.includes(key))) {
                tags.columns[key].display = true;
                const found = ((configByType === null || configByType === void 0 ? void 0 : configByType.requiredTags) || [])
                    .map((col) => col.includes(':') ? col.split(':') : [col, ''])
                    .find(([colName]) => colName === key);
                if (found) {
                    tags.columns[key].value = found[1];
                }
            }
        });
    };
    const setSwitchesDisplayAndValue = (config, configByType, switches) => {
        const notDisabledSwitchesConfig = Object.keys(config)
            .filter(key => key.endsWith('Switch') && !(configByType === null || configByType === void 0 ? void 0 : configByType.disabledTags.includes(key)))
            .reduce((acc, key) => {
            acc[key] = config[key];
            return acc;
        }, {});
        Object.entries(notDisabledSwitchesConfig).forEach(([switchKey, switchConfig]) => {
            const required = switchConfig.requiredTags || [];
            const hasRequiredDisplayed = required.length === 0 || required.some((col) => tags.columns[col] && tags.columns[col].display === true);
            if (hasRequiredDisplayed) {
                tags.switches[switchKey].display = true;
                if (switches[switchKey] === true) {
                    tags.switches[switchKey].value = true;
                }
            }
        });
    };
    const handleExportPartner = () => {
        if (isExportPartner.value) {
            tags.columns.listPriceColumn.display = false;
            tags.columns.wholesalePriceColumn.display = true;
            tags.switches.retailPriceSwitch.display = false;
            tags.switches.retailPriceSwitch.value = false;
            tags.switches.grossPriceSwitch.display = false;
            tags.switches.grossPriceSwitch.value = false;
        }
    };
    const handleRetailPriceSwitch = () => {
        if (tags.switches.retailPriceSwitch.value) {
            tags.columns.retailPriceColumn.display = true;
            tags.columns.wholesalePriceColumn.display = false;
        }
        else {
            tags.columns.retailPriceColumn.display = false;
            tags.columns.wholesalePriceColumn.display = true;
        }
    };
    const handleCustomPriceSwitch = () => {
        if (tags.switches.customPriceSwitch.value) {
            tags.columns.customPriceColumn.display = true;
            tags.columns.listPriceColumn.display = false;
            tags.columns.wholesalePriceColumn.display = false;
        }
        else {
            tags.columns.customPriceColumn.display = false;
        }
    };
    const reset = () => {
        const defaults = getDefaultTags();
        Object.keys(defaults.columns).forEach((key) => {
            tags.columns[key].display = defaults.columns[key].display;
            tags.columns[key].value = defaults.columns[key].value;
        });
        Object.keys(defaults.switches).forEach((key) => {
            tags.switches[key].display = defaults.switches[key].display;
            tags.switches[key].value = defaults.switches[key].value;
        });
        Object.keys(defaults.searchViews).forEach((key) => {
            tags.searchViews[key].display = defaults.searchViews[key].display;
        });
    };
    return {
        tags,
        calculateTags,
        reset,
        isExportPartner,
        customerCurrencyCode,
        activeColumnCount
    };
});
